// extracted by mini-css-extract-plugin
export var itemCarousel = "ItemCarousel-module--itemCarousel--4a69e";
export var itemCarousel___four = "ItemCarousel-module--itemCarousel___four--7c902";
export var itemCarousel___one = "ItemCarousel-module--itemCarousel___one--2f455";
export var itemCarousel___three = "ItemCarousel-module--itemCarousel___three--1c5e0";
export var itemCarousel___two = "ItemCarousel-module--itemCarousel___two--7c9a7";
export var itemCarousel__content = "ItemCarousel-module--itemCarousel__content--c6626";
export var itemCarousel__desc = "ItemCarousel-module--itemCarousel__desc--a7b0a";
export var itemCarousel__desktop = "ItemCarousel-module--itemCarousel__desktop--4930e";
export var itemCarousel__header = "ItemCarousel-module--itemCarousel__header--57ae7";
export var itemCarousel__headerRight = "ItemCarousel-module--itemCarousel__headerRight--83a61";
export var itemCarousel__image = "ItemCarousel-module--itemCarousel__image--ef9b4";
export var itemCarousel__inner = "ItemCarousel-module--itemCarousel__inner--beff5";
export var itemCarousel__link = "ItemCarousel-module--itemCarousel__link--695e4";
export var itemCarousel__linkVideoWrapper = "ItemCarousel-module--itemCarousel__linkVideoWrapper--09e16";
export var itemCarousel__mobile = "ItemCarousel-module--itemCarousel__mobile--315a9";
export var itemCarousel__text = "ItemCarousel-module--itemCarousel__text--47a17";
export var itemCarousel__title = "ItemCarousel-module--itemCarousel__title--77f4a";